import React, { Component } from 'react';
import { Form, Modal } from 'antd';
import SeatInput from './SeatInput';

class Demo extends Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleSubmit(values);
      }
    });
  };

  checkPrice = (rule, value, callback) => {
    if (value.num > 0) {
      callback();
      return;
    }
    callback('Price must greater than zero!');
  };

  render() {
    const {
      form: { getFieldDecorator },
      title,
    } = this.props;
    return (
      <Modal
        visible
        title={title}
        onCancel={this.props.onCancel}
        width={300}
        onOk={this.handleSubmit}
      >
        <Form layout="inline">
          <Form.Item>
            {getFieldDecorator('seat', {
              initialValue: { num: 0, type: '0' },
              rules: [{ validator: this.checkPrice }],
            })(<SeatInput />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Demo);



// WEBPACK FOOTER //
// ./src/components/incubator/seat/SeatAdd.js